var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"activity"},domProps:{"innerHTML":_vm._s(_vm.yyhd)}},[_c('img',{attrs:{"src":require("../../assets/1-200H1150515962.jpg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }